import cn from 'classnames';
import { FC } from 'react';

import { DocumentSection } from '@/shared/api/transcriptor/transcriptorApi';

import { getDocumentSectionContent } from '../lib/getDocumentSectionContent';

import styles from './DocumentSections.module.scss';
import { buildDocumentRenderItems } from './lib/buildDocumentRenderItems';

type DocumentSectionsProps = {
  sections: DocumentSection[];
  className?: string;
};

export const DocumentSections: FC<DocumentSectionsProps> = (props) => {
  const { sections, className } = props;

  const items = buildDocumentRenderItems(sections);

  if (items.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(styles.container, className)}
      data-component="encounter-document-sections"
    >
      {items.map((item, index) => {
        if (item.kind === 'group') {
          return (
            <section
              key={`group-${item.category}-${index}`}
              className={styles.standaloneSection}
            >
              <h3 className={styles.categoryHeading}>{item.category}</h3>
              <dl className={styles.list}>
                {item.sections.map((section, sectionIndex) => (
                  <div
                    key={section.code ?? `${item.category}-${sectionIndex}`}
                    className={styles.row}
                  >
                    <dt className={styles.label}>{section.title}</dt>
                    <dd className={styles.value}>
                      {getDocumentSectionContent(section)}
                    </dd>
                  </div>
                ))}
              </dl>
            </section>
          );
        }

        return (
          <section
            key={item.section.code ?? `standalone-${index}`}
            className={styles.standaloneSection}
          >
            <h3 className={styles.standaloneHeading}>{item.section.title}</h3>
            <p className={styles.standaloneContent}>
              {getDocumentSectionContent(item.section)}
            </p>
          </section>
        );
      })}
    </div>
  );
};
